module.exports = __webpack_public_path__ + "assets/img/spinner.94dd5b7.gif";


//////////////////
// WEBPACK FOOTER
// ../common/assets/img/spinner.gif
// module id = 861
// module chunks = 1